var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4CBA64",
    d: "M14.786 6.969a1.7 1.7 0 0 1 .356-.54l5.43 5.344l-5.443 5.786l-3.896-3.986a1.606 1.606 0 0 1 2.301 0l1.599 1.633l3.137-3.429l-3.128-2.991a1.67 1.67 0 0 1-.352-1.817zm1.5 4.817a1.071 1.071 0 1 1-2.143 0a1.071 1.071 0 0 1 2.143 0m-7.427 5.786a1.69 1.69 0 0 0 0-2.358L5.73 11.807l3.142-3.013l1.594 1.633a1.6 1.6 0 0 0 1.148.489c.433 0 .815-.292 1.115-.604L8.872 6.437l-5.443 5.37zm.998-5.786a1.072 1.072 0 1 1-2.143 0a1.072 1.072 0 0 1 2.143 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKub);
export default __webpack_public_path__ + "static/media/kub.439f91c565c4953481505a65f93b9598.svg";
export { ForwardRef as ReactComponent };